/**
 * Parses payment amount strings from CurrencyInput, loan payoff fields, and manual entry.
 * Supports US (12,279.26), decimal comma (12279,26 / 12000,00), and cent-digit input.
 */
export function parsePaymentAmount(value) {
  if (value === null || value === undefined || value === '') {
    return NaN;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.round(value * 100) / 100 : NaN;
  }

  let str = String(value).trim().replace(/^\$/, '');
  if (str === '') {
    return NaN;
  }

  const hasDot = str.includes('.');
  const hasComma = str.includes(',');

  if (hasDot && hasComma) {
    if (str.lastIndexOf(',') > str.lastIndexOf('.')) {
      str = str.replace(/\./g, '').replace(',', '.');
    } else {
      str = str.replace(/,/g, '');
    }
    const parsed = parseFloat(str);
    return Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : NaN;
  }

  if (hasComma && !hasDot) {
    const parts = str.split(',');
    if (parts.length === 2 && parts[1].length > 0 && parts[1].length <= 2) {
      const whole = parts[0].replace(/\D/g, '');
      const cents = parts[1].replace(/\D/g, '');
      const parsed = parseFloat(`${whole}.${cents.padEnd(2, '0').slice(0, 2)}`);
      return Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : NaN;
    }

    const parsed = parseFloat(str.replace(/,/g, ''));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : NaN;
  }

  if (hasDot && !hasComma) {
    const parsed = parseFloat(str);
    return Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : NaN;
  }

  const digits = str.replace(/\D/g, '');
  if (digits === '') {
    return NaN;
  }

  const parsed = parseInt(digits, 10) / 100;
  return Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : NaN;
}

export function paymentAmountsMatch(first, second, tolerance = 0.005) {
  const a = typeof first === 'number' ? first : parsePaymentAmount(first);
  const b = typeof second === 'number' ? second : parsePaymentAmount(second);
  if (Number.isNaN(a) || Number.isNaN(b)) {
    return false;
  }

  return Math.abs(a - b) <= tolerance;
}
